var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_loading)?_c('span',{staticClass:"loading"},[_vm._v("読み込み中"),_c('span')]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }